import { render } from "./TableNormal.vue?vue&type=template&id=394b16f0&scoped=true"
import script from "./TableNormal.vue?vue&type=script&lang=js"
export * from "./TableNormal.vue?vue&type=script&lang=js"

import "./TableNormal.vue?vue&type=style&index=0&id=394b16f0&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394b16f0"]])

export default __exports__